// components/common/FormSelect.js
import React from "react";

const FormSelect = ({ label, name, options, register, errors }) => {
  return (
    <div className="form-group">
      <label className="form-label">{label}</label>
      <select className="form-select" {...register(name)}>
        <option value="">Select {label}</option>
        {options.map((option, index) => (
          <option key={index} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      <p className="text-danger">{errors[name]?.message}</p>
    </div>
  );
};

export default FormSelect;
